module.exports = __webpack_public_path__ + "36d50c1381fda7c71d12b6643cbe1ee0.svg";